<template>
    <div class="footer">

        <div class="info text-muted">
            © {{year}} Swenja Kastenmiller
        </div>

        <div class="navigation">
            <b-navbar toggleable="sm" type="light" variant="light">

                <b-navbar-toggle target="nav-collapse-bottom"></b-navbar-toggle>

                <b-collapse id="nav-collapse-bottom" is-nav>
                    <b-navbar-nav>
                        <a v-b-modal.modal-impressum class="nav-item nav-link">Impressum</a>
                        <a v-b-modal.modal-data-protection class="nav-item nav-link">Datenschutzerklärung</a>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>

        <b-modal id="modal-impressum" size="xl" scrollable title="Impressum" hide-footer>
            <impressum></impressum>
            <div slot="modal-footer">
            </div>
        </b-modal>

        <b-modal id="modal-data-protection" size="xl" scrollable title="Datenschutzerklärung" hide-footer>
            <data-protection></data-protection>
            <div slot="modal-footer">
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Impressum from "./Impressum";
    import DataProtection from "./DataProtection";

    export default {
        name: 'Footer',
        components: {
            impressum: Impressum,
            'data-protection': DataProtection
        },
        computed: {
            year() {
                return new Date().getFullYear();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .footer {
        background-color: #f8f9fa;
        padding-left: 2rem;
        box-shadow: 0 6px 6px 6px black;
        display: flex;
        justify-content: space-between;
    }

    .info {
        margin-top: 18px;
    }

    .nav-item {
        cursor: pointer;
    }
</style>
